import { create } from "zustand";
import { persist } from "zustand/middleware";
import { PermissionsResponseMenu } from "interfaces";

interface layoutInterface {
  menuCache: Record<number, PermissionsResponseMenu[]>;
  shouldRefreshMenu: boolean;
  setMenuCache: (userId: number, data: PermissionsResponseMenu[]) => void;
  getMenuCache: (userId: number) => PermissionsResponseMenu[] | undefined;
  addPermissionToCache: (userId: number, permiso: PermissionsResponseMenu) => void;
  removePermissionFromCache: (userId: number, url: string) => void;
  triggerRefreshMenu: () => void;
  resetRefreshFlag: () => void;
  clearCache: () => void; 
}

export const layoutStore = create<layoutInterface>()(
  persist(
    (set, get) => ({
      menuCache: {},
      shouldRefreshMenu: false,

      setMenuCache: (userId, data) =>
        set((state) => ({
          menuCache: { ...state.menuCache, [userId]: data },
        })),

      getMenuCache: (userId) => get().menuCache[userId],

      addPermissionToCache: (userId, permiso) => {
        const current = get().menuCache[userId] || [];
        set((state) => ({
          menuCache: {
            ...state.menuCache,
            [userId]: [...current, permiso],
          },
        }));
      },

      removePermissionFromCache: (userId, url) => {
        const current = get().menuCache[userId] || [];
        set((state) => ({
          menuCache: {
            ...state.menuCache,
            [userId]: current.filter((p) => p.option.url !== url),
          },
        }));
      },

      triggerRefreshMenu: () => set({ shouldRefreshMenu: true }),
      resetRefreshFlag: () => set({ shouldRefreshMenu: false }),

      clearCache: () => set({ menuCache: {}, shouldRefreshMenu: false }),
    }),
    {
      name: "layout-menu-cache", 
    }
  )
); 
